export default __webpack_public_path__ + "static/media/all-trips.759e1cad.svg";